import React from 'react';

import { DroppableFileInput } from './DroppableFileInput';
import { useImagesUploadMutation } from '../../hooks/useImagesUploadMutation';
import usePhotoShootContext from '../../hooks/usePhotoShootContext';
import { PhotoShootModel } from '../../types';

type ImagesUploaderProps = {
  onUploadFinished: (images: PhotoShootModel['images']) => void;
};

export const ImagesUploader = ({ onUploadFinished }: ImagesUploaderProps) => {
  const { venueId, token } = usePhotoShootContext();
  const { handlePhotosUpload, errorMessage, isLoading, progress } = useImagesUploadMutation({
    venueId,
    token,
    onUploadFinished,
  });

  return (
    <DroppableFileInput onDrop={handlePhotosUpload} error={errorMessage} isLoading={isLoading} progress={progress} />
  );
};
